// ============================================================
// หน้า RecordWaterUsage — บันทึกค่าใช้จ่าย (จดมิเตอร์รายห้อง)
// ------------------------------------------------------------
// หน้าที่ใช้จดเลขมาตรน้ำและออกบิลของแต่ละบ้าน ทีละห้อง
//
// ลำดับการทำงาน
//   1. โหลดตั้งค่าโครงการก่อน (อัตราค่าน้ำ/ค่าใช้จ่ายอื่น) — ต้องมาก่อน ไม่งั้นคิดค่าน้ำได้ 0
//   2. โหลดรายการบ้านเลขที่ที่ "ยังไม่ได้จด" ในรอบเดือนนี้
//   3. เลือกบ้าน → ระบบดึงเลขมาตรเดือนก่อน + ค่าใช้จ่ายประจำของห้องนั้นมาเติมให้
//   4. กรอกเลขมาตรเดือนนี้ → คำนวณหน่วยที่ใช้และค่าน้ำให้อัตโนมัติ
//   5. กด "เพิ่มข้อมูล" เพื่อบันทึก แล้วเด้งไปห้องถัดไป
//
// เข้าหน้านี้พร้อม ?id=<record_water_id> = โหมดแก้ไขบิลใบเดิม (บันทึกแล้วกลับไปหน้ารายการ)
//
// การกรอกออกแบบให้ใช้แป้นพิมพ์อย่างเดียวได้ — กด Enter แล้วเด้งไปช่องถัดไปตามลำดับ
// ============================================================

import React, { Component } from "react";
import Select from "react-select";

import "../../shared/config/global.js";
import "../../assets/css/bootstrap.css";
import Navbar from "../../shared/layout/Navbar";
import {
  loading,
  tokens,
  select_style,
  alert,
  alert_url,
  toFixed,
  GET,
  POST,
  PUT,
  format_date,
  float,
  DatePicker,
  getStorage,
  calculate_water,
  cal_water_bill,
  getWaterSetting,
  calcFireCost,
  calcCommonExpenses,
  billTotal,
  permission,
} from "../../shared/index.js";

const perm = permission("record-water-usage");

// สถานะมิเตอร์ของห้อง
const METER_STATUS = [
  { value: 0, label: "" },
  { value: 1, label: "ปกติ" },
  { value: 2, label: "ตัดมิเตอร์" },
];
const meterStatusOption = (value) => METER_STATUS.find((s) => s.value === value) || METER_STATUS[0];

export default class RecordWaterUsage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      update: false, // true = โหมดแก้ไขบิลเดิม (เข้ามาพร้อม ?id=)
      data_address: null, // รายการบ้านเลขที่ที่ยังจดไม่ครบในรอบนี้

      // ข้อมูลบิลที่กำลังกรอก
      record_water_id: "",
      address_number: "",
      full_name: "",
      room_size: 0,
      status_meter: 0,
      date_of_note: new Date(),
      last_gauge_number: 0,
      current_gauge_number: 0,
      unit_used: 0,

      // ค่าใช้จ่ายในบิล
      water_bill: 0,
      equipment_maintenance_fee: 0,
      common_expenses: 0,
      waste_cost: 0,
      cable_cost: 0,
      status_cable: false, // ห้องนี้เก็บค่าเคเบิลไหม
      fire_cost: 0,
      other_income: 0,
      add_debt: 0,
      reduce_debt: 0,
      remark_add_debt: "",
      remark_reduce_debt: "",
      total_amount: 0,

      // ค่าจากตั้งค่าโครงการ
      setting_water_id: getStorage("water_id"),
      water_charge_start: 0,
      water_charge_end: 0,
      water_charge_price: 0,
      water_rate_list: [],
      water_calculate_type: 2,
      common_expenses_type: false, // true = ค่าส่วนกลางคิดตามขนาดห้อง
      common_expenses_text: 0, // อัตราค่าส่วนกลางต่อ ตรม. (ใช้แสดงบนป้ายช่องกรอก)
      penalty_day_list: [],
      penalty_month_list: [],
      payment_deadline: 0,
      fire_month: "",
      max_date: null, // วันที่จดสูงสุดที่เลือกได้ (โหมดแก้ไข)
    };
  }

  async componentDidMount() {
    // โหลดอัตราค่าน้ำให้เข้า state ก่อน แล้วค่อยเปิดบิล — กัน cal_water(0) ได้ 0 เพราะ settings ยังไม่มา
    if (!perm.view) return;
    await this.GetSetting();
    await this.GetAddressNumberAll();
  }

  // ---------- ตัวช่วย ----------

  pid = () => getStorage("project_id");

  // คำนวณค่าน้ำจากหน่วยที่ใช้ ตามสูตรที่โครงการตั้งไว้
  cal_water = (unit_used) => cal_water_bill(unit_used, this.state);

  // ยอดรวมของบิลใบนี้ — ค่าเคเบิลนับเฉพาะห้องที่เปิดเก็บ (status_cable)
  getTotal = (s = this.state) => billTotal({ ...s, cable_cost: s.status_cable ? s.cable_cost : 0 });

  // id ของบิลที่กำลังแก้ไข (ถ้าเข้ามาแบบแก้ไข)
  editingId = () => this.props.location.query.id;

  // ---------- โหลดข้อมูล ----------

  // ตั้งค่าโครงการ + หา "รอบเดือน" ที่ควรจด
  // ถ้าตั้ง payment_deadline ไว้ และวันนี้ยังไม่ถึงวันนั้น แปลว่ายังอยู่ในรอบของเดือนก่อน
  GetSetting = async () => {
    loading(true);
    const d = await getWaterSetting(this.state.setting_water_id);
    if (!d) {
      loading(false);
      return;
    }

    let date_of_note = new Date();
    if (d.payment_deadline) {
      const deadline = new Date();
      deadline.setDate(Number(d.payment_deadline));
      if (new Date() < deadline) deadline.setMonth(deadline.getMonth() - 1);
      date_of_note = deadline;
    }

    await new Promise((resolve) => {
      this.setState(
        {
          water_charge_start: Number(d.water_charge.water_charge_start),
          water_charge_end: Number(d.water_charge.water_charge_end),
          water_charge_price: Number(d.water_charge.water_charge_price),
          water_rate_list: d.water_rate_list,
          water_calculate_type: Number(d.water_calculate_type) || 2,
          add_debt: Number(d.add_debt),
          reduce_debt: Number(d.reduce_debt),
          fire_month: d.fire_month,
          fire_cost: calcFireCost(d, format_date(new Date(), "m")),
          common_expenses_type: d.common_expenses_type,
          common_expenses_text: d.common_expenses,
          payment_deadline: d.payment_deadline,
          penalty_day_list: d.penalty_day_list,
          penalty_month_list: d.penalty_month_list,
          meter_cut_month: d.meter_cut_month,
          meter_cut_date: d.meter_cut_date,
          meter_convergence: d.meter_convergence,
          date_of_note,
        },
        resolve
      );
    });
    loading(false);

    // ตั้งค่าไม่ครบ = คิดเงินไม่ได้ ต้องไล่ไปตั้งค่าก่อน
    if (!d.payment_close_time || !d.meter_cut_date || !d.penalty_day_list.length || !d.penalty_month_list.length) {
      alert_url("warning", "แจ้งเตือน", "ท่านยังไม่ทำการตั้งค่าอัตราค่าน้ำก่อนทำการเริ่มต้นใช้งานระบบ", "/manage-water");
    }
  };

  // รายการบ้านเลขที่ที่ยังต้องจดในรอบเดือนนี้ (เรียงตามเลขบ้านแบบตัวเลข)
  GetAddressNumberAll = async () => {
    const r = await GET(tokens, `v1/TH/record-water/address-list/${this.pid()}`, {
      now_month: Number(format_date(this.state.date_of_note, "mm")),
      now_year: Number(format_date(this.state.date_of_note, "yyyy", "en")),
    });
    if (!r?.status) return;

    const list = r.data.data.sort((a, b) => a.address_number.localeCompare(b.address_number, undefined, { numeric: true }));
    this.setState({ data_address: list });

    if (this.editingId()) {
      // โหมดแก้ไข — โหลดบิลใบเดิมมาแสดง
      this.setState({ update: true, record_water_id: this.editingId() }, () => this.GetById(this.editingId()));
    } else if (!list.length) {
      alert("warning", "แจ้งเตือน", "ไม่มีข้อมูลบ้านเลขที่ในเดือนนี้");
    } else {
      // เปิดบ้านหลังแรกในรายการให้เลย ผู้ใช้จะได้กรอกต่อเนื่อง
      this.setState({ address_number: { value: list[0].address_number, label: list[0].address_number } }, this.GetAddressById);
    }
  };

  // ข้อมูลตั้งต้นของบ้านที่เลือก (เลขมาตรเดือนก่อน + ค่าใช้จ่ายประจำของห้อง)
  GetAddressById = async () => {
    const r = await GET(tokens, `v1/TH/record-water/address-number/detail/${this.pid()}`, {
      address_number: this.state.address_number?.value || "",
      date_of_note: format_date(this.state.date_of_note || new Date(), "yyyy-mm-dd", "en"),
    });

    if (r?.status) {
      const d = r.data.data;
      this.setState({
        room_size: d.room_size,
        last_gauge_number: d.last_gauge_number,
        // ตั้งเลขมาตรเดือนนี้เท่าเดือนก่อนไว้ก่อน (หน่วยที่ใช้ = 0) รอผู้ใช้กรอกทับ
        current_gauge_number: d.last_gauge_number,
        unit_used: 0,
        water_bill: Number(this.state.water_charge_price), // ยังไม่ใช้น้ำ = จ่ายอัตราขั้นต่ำ
        cable_cost: d.cable_cost,
        equipment_maintenance_fee: d.equipment_maintenance_fee,
        waste_cost: d.waste_cost,
        // ค่าส่วนกลางตามขนาดห้อง ปัดเป็นทศนิยม 2 ตำแหน่ง (ใช้สูตรเดียวกับหน้านำเข้าไฟล์และหน้าจดแบบพัก)
        common_expenses: calcCommonExpenses(this.state.common_expenses_type, d.common_expenses, d.room_size),
        status_cable: d.status_cable,
        full_name: d.full_name,
        status_meter: meterStatusOption(d.status_meter),
      });
    }
    // เด้ง cursor ไปช่องเลขมาตรเดือนนี้ให้พิมพ์ต่อได้เลย
    setTimeout(() => document.getElementById("current_gauge_number")?.focus(), 100);
  };

  // โหลดบิลใบเดิม (โหมดแก้ไข)
  GetById = async (id) => {
    loading(true);
    const r = await GET(tokens, `v1/TH/record-water/detail/${id}`, null);
    if (!r?.status) return;

    const d = r.data.data;
    this.setState(
      {
        data_address: [...(this.state.data_address || []), { value: d.address_number, label: d.address_number }],
        record_water_id: d.record_water_id,
        last_gauge_number: d.last_gauge_number,
        current_gauge_number: d.current_gauge_number,
        unit_used: d.unit_used,
        water_bill: d.water_bill,
        address_number: { value: d.address_number, label: d.address_number },
        equipment_maintenance_fee: d.equipment_maintenance_fee,
        common_expenses: d.common_expenses,
        waste_cost: d.waste_cost,
        cable_cost: d.cable_cost,
        status_cable: d.cable_cost !== 0,
        other_income: d.other_income,
        add_debt: d.add_debt,
        reduce_debt: d.reduce_debt,
        fire_cost: d.fire_cost,
        remark_add_debt: d.remark_add_debt,
        remark_reduce_debt: d.remark_reduce_debt,
        total_amount: d.total_amount,
        full_name: d.full_name,
        room_size: d.room_size,
        date_of_note: d.datetime_create,
        status_meter: meterStatusOption(d.status_meter),
        // แก้ไขได้ในช่วงวันจดเดิมถึงวันครบกำหนดชำระเท่านั้น
        max_date: this.editingId() ? format_date(new Date(new Date(d.datetime_create).setDate(this.state.payment_deadline)), "yyyy-mm-dd", "en") : this.state.max_date,
      },
      () => {
        loading(false);
        // คิดค่าน้ำใหม่ด้วยสูตรปัจจุบัน เผื่ออัตราถูกแก้หลังออกบิล
        this.setState({ water_bill: this.cal_water(d.unit_used) });
      }
    );
  };

  // ---------- บันทึก ----------

  processSave = async (isUpdate) => {
    if (Number(this.state.unit_used) < 0) return alert("warning", "แจ้งเตือน", "ไม่สามารถกรอกเลขมาตรในเดือนนี้น้อยกว่าเดือนก่อนได้");
    loading(true);

    const datetime = format_date(this.state.date_of_note, "yyyy-mm-dd hh:mm", "en");
    const data = {
      ...this.state,
      address_number: this.state.address_number?.label || "",
      status_meter: this.state.status_meter?.value || 0,
      cable_cost: this.state.status_cable ? Number(this.state.cable_cost) : 0,
      total_amount: this.getTotal(),
      datetime_create: isUpdate ? this.state.date_of_note : datetime,
    };
    if (!isUpdate) data.date_of_note = datetime;

    const r = isUpdate ? await PUT(tokens, `v1/TH/record-water/create/${this.pid()}`, data) : await POST(tokens, `v1/TH/record-water/create/${this.pid()}`, data);

    if (r?.status) {
      if (isUpdate && this.editingId()) {
        // แก้ไขบิลเดิม → ต้องคิดยอดค้าง/เบี้ยปรับของบ้านหลังนี้ใหม่ แล้วกลับไปหน้ารายการ
        calculate_water(this.state.address_number?.label || "");
        alert_url("success", "บันทึกข้อมูลสำเร็จ", "ข้อมูลได้ถูกบันทึกเรียบร้อยแล้ว", "/water-usage-info");
      } else {
        // จดใหม่ → โหลดรายการบ้านที่เหลือ เพื่อเด้งไปห้องถัดไป
        setTimeout(this.GetAddressNumberAll, 1);
      }
      this.clearBillForm();
    }
    loading(false);
  };

  // ล้างเฉพาะข้อมูลบิล (ค่าตั้งค่าโครงการยังอยู่)
  clearBillForm = () => {
    this.setState({
      last_gauge_number: 0,
      current_gauge_number: 0,
      unit_used: 0,
      water_bill: 0,
      address_number: "",
      equipment_maintenance_fee: 0,
      common_expenses: 0,
      waste_cost: 0,
      cable_cost: 0,
      other_income: 0,
      add_debt: 0,
      reduce_debt: 0,
      remark_add_debt: "",
      remark_reduce_debt: "",
      total_amount: 0,
      full_name: "",
      room_size: 0,
      status_meter: 0,
    });
  };

  // ---------- ตัวช่วยแสดงผล ----------

  // กด Enter แล้วไปช่องถัดไป (nextId = "SUBMIT" คือกดบันทึกเลย)
  onEnter = (nextId) => (e) => {
    if (e.key !== "Enter" || !nextId) return;
    if (nextId === "SUBMIT") this.processSave(this.state.update);
    else document.getElementById(nextId)?.focus();
  };

  // ช่องกรอกตัวเลขในฟอร์มบิล
  //   nextId ไม่ระบุ = ช่องอ่านอย่างเดียว (ยกเว้นช่องหมายเหตุที่แก้ได้เสมอ)
  //   extra   = element เสริมข้างป้ายชื่อ เช่น checkbox เปิด/ปิดค่าเคเบิล
  renderField = (label, id, field, nextId = null, extra = null) => {
    const isRemark = id === "remark_add_debt" || id === "remark_reduce_debt";
    return (
      <div className="col-12 col-md-6 col-lg-3 mb-2">
        <label>
          {label} {extra}
        </label>
        <input
          type="text"
          id={id}
          className="form-control bg-contain border-0 mx-1 mb-2"
          placeholder="กรอกข้อมูล"
          value={this.state[field]}
          disabled={!nextId && !isRemark}
          onChange={(e) => float(e.target.value) && this.setState({ [field]: e.target.value || 0 })}
          onKeyUp={nextId ? this.onEnter(nextId) : undefined}
        />
      </div>
    );
  };

  // กรอกเลขมาตร → คำนวณหน่วยที่ใช้และค่าน้ำใหม่ทันที
  // NOTE เดิมเก็บลง state ด้วย Number(value) ทันที — พิมพ์ "10." แล้วจุดหายทุกครั้ง
  //      กรอกเลขมาตรที่มีทศนิยมไม่ได้เลย ตอนนี้เก็บข้อความที่พิมพ์ไว้ตามจริง
  //      แล้วแปลงเป็นตัวเลขเฉพาะตอนคำนวณ
  onChangeGauge = (field, value) => {
    if (!float(value)) return;
    const gauge = Number(value || 0);
    const unit_used = field === "current_gauge_number" ? gauge - Number(this.state.last_gauge_number) : Number(this.state.current_gauge_number) - gauge;
    this.setState({ [field]: value, unit_used }, () => this.setState({ water_bill: this.cal_water(this.state.unit_used) }));
  };

  render() {
    const s = this.state;

    return (
      <div className="w-100 min-vh-100 fade-in">
        <Navbar page1="หน้าหลัก" page2="บันทึกค่าใช้จ่าย" />
        <div className="body">
          <div className="p-3">
            <div className="w-100">
              {perm.view && (
                <div className="d-flex row mx-0 align-items-center justify-content-between">
                  <h4 className="mb-3">
                    <b>
                      บันทึกค่าใช้จ่าย เดือน{format_date(new Date(), "mmmm")} พ.ศ. {format_date(new Date(), "yyyy")}
                    </b>
                  </h4>
                  <button className="btn btn-outline-primary px-4 mx-1 mb-3" onClick={() => (window.location.href = "/water-usage-info")}>
                    รายการทั้งหมด
                  </button>
                </div>
              )}

              {/* ส่วนที่ 1 — ข้อมูลห้องและเลขมาตร */}
              <div className="card border-0 p-3 mb-3">
                <div className="row mx-0">
                  <div className="col-12 col-md-6 col-lg-3 mb-2">
                    <label>บ้านเลขที่</label>
                    <Select
                      className="form-control bg-contain border-0 w-100 select-search"
                      styles={select_style}
                      options={s.data_address?.map((i) => ({ value: i.address_number, label: i.address_number, ...i })) || []}
                      onChange={(e) => this.setState({ address_number: e }, this.GetAddressById)}
                      value={s.address_number}
                    />
                  </div>

                  {this.renderField("ชื่อ-นามสกุล", "full_name", "full_name")}

                  <div className="col-12 col-md-6 col-lg-3 mb-2">
                    <label>ขนาดห้อง (ตรม.)</label>
                    <input type="text" className="form-control bg-contain border-0 mx-1 mb-2" value={toFixed(s.room_size)} disabled />
                  </div>

                  <div className="col-12 col-md-6 col-lg-3 mb-2">
                    <label>สถานะมิเตอร์น้ำ</label>
                    <Select className="form-control bg-contain border-0 w-100 select-search" styles={select_style} options={METER_STATUS} value={s.status_meter} isDisabled={true} />
                  </div>

                  <div className="col-12 col-md-6 col-lg-3 mb-2">
                    <label>วันที่จด</label>
                    <DatePicker
                      className="form-control bg-contain border-0 w-100"
                      value={s.date_of_note}
                      min={s.max_date ? format_date(new Date(new Date(s.max_date).setDate(new Date(s.max_date).getDate() - 1)), "yyyy-mm-dd", "en") : null}
                      max={s.max_date || null}
                      onChange={(e) => this.setState({ date_of_note: e }, () => !this.editingId() && this.GetAddressNumberAll())}
                    />
                  </div>

                  <div className="col-12 col-md-6 col-lg-3 mb-2">
                    <label>เลขมาตรเดือนก่อน</label>
                    <input
                      type="text"
                      id="last_gauge_number"
                      className="form-control bg-contain border-0 mx-1 mb-2"
                      value={s.last_gauge_number}
                      onKeyUp={this.onEnter("current_gauge_number")}
                      onChange={(e) => this.onChangeGauge("last_gauge_number", e.target.value)}
                    />
                  </div>

                  <div className="col-12 col-md-6 col-lg-3 mb-2">
                    <label>เลขมาตรเดือนนี้</label>
                    <input
                      type="text"
                      id="current_gauge_number"
                      className="form-control bg-contain border-0 mx-1 mb-2"
                      value={s.current_gauge_number}
                      onKeyUp={this.onEnter("other_income")}
                      onChange={(e) => this.onChangeGauge("current_gauge_number", e.target.value)}
                    />
                  </div>

                  {this.renderField("จำนวนหน่วยที่ใช้", "unit_used", "unit_used")}
                </div>
              </div>

              {/* ส่วนที่ 2 — ค่าใช้จ่ายในบิล + ยอดรวม */}
              <div className="card border-0 p-3 mb-3">
                <div className="row mx-0">
                  {this.renderField("ค่าน้ำประปา", "water_bill", "water_bill", "equipment_maintenance_fee")}
                  {this.renderField("ค่ารักษาอุปกรณ์", "equipment_maintenance_fee", "equipment_maintenance_fee", "common_expenses")}
                  {this.renderField(`ค่าส่วนกลาง ${s.common_expenses_type ? "( " + toFixed(s.common_expenses_text) + " บาท/ตรม. )" : ""}`, "common_expenses", "common_expenses", "waste_cost")}
                  {this.renderField("ค่าขยะ", "waste_cost", "waste_cost", "cable_cost")}
                  {/* ค่าเคเบิลมี checkbox กำกับ — ห้องที่ไม่ได้เก็บจะไม่ถูกนำไปรวมยอด */}
                  {this.renderField(
                    "ค่าเคเบิล",
                    "cable_cost",
                    "cable_cost",
                    "fire_cost",
                    s.cable_cost !== 0 && <input className="ml-2" type="checkbox" onChange={(e) => this.setState({ status_cable: e.target.checked })} checked={s.status_cable} />
                  )}
                  {this.renderField("ค่าเบี้ยประกัน", "fire_cost", "fire_cost", "other_income")}
                  {this.renderField("รายได้อื่น", "other_income", "other_income", "add_debt")}
                  {this.renderField("เพิ่มหนี้", "add_debt", "add_debt", "remark_add_debt")}

                  <div className="col-12 col-md-6 col-lg-3 mb-2">
                    <label>หมายเหตุเพิ่มหนี้</label>
                    <input
                      type="text"
                      id="remark_add_debt"
                      className="form-control bg-contain border-0 mx-1 mb-2"
                      placeholder="กรอกข้อมูล"
                      onChange={(e) => this.setState({ remark_add_debt: e.target.value })}
                      onKeyUp={this.onEnter("reduce_debt")}
                      value={s.remark_add_debt}
                    />
                  </div>

                  {this.renderField("ลดหนี้", "reduce_debt", "reduce_debt", "remark_reduce_debt")}

                  <div className="col-12 col-md-6 col-lg-3 mb-2">
                    <label>หมายเหตุลดหนี้</label>
                    <input
                      type="text"
                      id="remark_reduce_debt"
                      className="form-control bg-contain border-0 mx-1 mb-2"
                      placeholder="กรอกข้อมูล"
                      onChange={(e) => this.setState({ remark_reduce_debt: e.target.value })}
                      onKeyUp={this.onEnter("SUBMIT")}
                      value={s.remark_reduce_debt}
                    />
                  </div>
                </div>

                <div className="d-flex align-items-end justify-content-between">
                  <div>
                    <label>รวมเป็นเงิน</label>
                    <h4>
                      <b>฿{toFixed(this.getTotal())}</b>
                    </h4>
                  </div>
                  {perm.create && (
                    <button className="btn btn-primary px-5" onClick={() => this.processSave(s.update)}>
                      เพิ่มข้อมูล
                    </button>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
